// วาดทะเบียน/เวลาเอง — สตรีมยิงตรงไม่มี overlay ของตัวเอง

import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Overlay, OverlayLine } from '../styles/cell'

export default function CellOverlay({ plateNo }) {
  // เดินเองทุกวินาที — กรอบไม่ได้วาดใหม่บ่อยพอให้นาฬิกาเดินตาม
  const [now, setNow] = useState(() => moment())
  useEffect(() => {
    const id = setInterval(() => setNow(moment()), 1000)
    return () => clearInterval(id)
  }, [])

  return (
    <Overlay>
      {plateNo && <OverlayLine>{plateNo}</OverlayLine>}
      <OverlayLine>{now.format('YYYY-MM-DD HH:mm:ss')}</OverlayLine>
    </Overlay>
  )
}

CellOverlay.propTypes = {
  plateNo: PropTypes.string,
}
